import { createActions, createReducer } from 'reduxsauce'

import ConsultaPrestadoresServicosEmpresasTerceirizadasService from '../../servicos/ConsultaPrestadoresServicosEmpresasTerceirizadasService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaPrestadoresServicosEmpresasTerceirizadasInicio: [],
    buscaConsultaPrestadoresServicosEmpresasTerceirizadasSucesso: ['consultaPrestadoresServicosEmpresasTerceirizadas'],
    buscaConsultaPrestadoresServicosEmpresasTerceirizadasErro: ['erro'],
    limpar: [],
    setConsultaPrestadoresServicosEmpresasTerceirizadasEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaPrestadoresServicosEmpresasTerceirizadas = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaPrestadoresServicosEmpresasTerceirizadasInicio())
        let serv = new ConsultaPrestadoresServicosEmpresasTerceirizadasService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaPrestadoresServicosEmpresasTerceirizadasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaPrestadoresServicosEmpresasTerceirizadasErro(error)))
    }
}

const buscaConsultaPrestadoresServicosEmpresasTerceirizadasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaPrestadoresServicosEmpresasTerceirizadasErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaPrestadoresServicosEmpresasTerceirizadasSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaPrestadoresServicosEmpresasTerceirizadas.resultado,
        dataSincronizacaoDados: action.consultaPrestadoresServicosEmpresasTerceirizadas.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaPrestadoresServicosEmpresasTerceirizadasEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS_INICIO]: buscaConsultaPrestadoresServicosEmpresasTerceirizadasInicio,
    [Types.BUSCA_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS_ERRO]: buscaConsultaPrestadoresServicosEmpresasTerceirizadasErro,
    [Types.BUSCA_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS_SUCESSO]: buscaConsultaPrestadoresServicosEmpresasTerceirizadasSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_PRESTADORES_SERVICOS_EMPRESAS_TERCEIRIZADAS_ESTADO_DT]: setConsultaPrestadoresServicosEmpresasTerceirizadasEstadoDT,
})
